import { MEDICATION_EYE_OPTIONS, MEDICATION_FREQUENCY_OPTIONS, MEDICATION_DURATION_OPTIONS } from 'store/medicalHistory';

export const EYE = MEDICATION_EYE_OPTIONS.reduce((acc, { id, label }) => ({ ...acc, [id]: label }), {});

export const FREQUENCY = MEDICATION_FREQUENCY_OPTIONS.reduce((acc, { id, label }) => ({ ...acc, [id]: label }), {});

export const DURATION = MEDICATION_DURATION_OPTIONS.reduce((acc, { id, label }) => ({ ...acc, [id]: label }), {});
